import React, {Component, Fragment} from "react";
import {promoTypeOptions} from "../config/constant";
import Api from "../../../../Services/Api";
import FlexView from "react-flexview";
import SimpleInput from "../../../../modules/SimpleInput";
import {ACTIVITY_TYPE, HttpStatus, Status} from "../../../common/Constants";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import {mapToDDL, mapToObjectDDL} from "../../../common/mapper";
import * as R from "ramda";
import ToggleButton from "react-toggle-button";
import M from "moment";
import {fetchDataAsync} from "../../../../Services/Utils";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class MasterPromoHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAllSelected: false,
            isAreaSelected: false,
            isSpecificSelected: false,
            confirmChangePromoType: false,
            tempPromoType: null,
            dataCabang: [],
            dataArea: [],
            promoTypeOptions: promoTypeOptions,
            dataLeasing: [],
        }
    }

    componentDidMount = async () => {
        this.fetchDataCabang();
        this.fetchDataArea();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.controls.applied.value !== prevProps.controls.applied.value) {
            if (this.props.controls.applied.value === "ALL") {
                this.setState((prevValue) => ({
                    ...prevValue,
                    isAllSelected: true,
                    isAreaSelected: false,
                    isSpecificSelected: false,
                }));
            }
            if (this.props.controls.applied.value === "WILAYAH") {
                this.setState((prevValue) => ({
                    ...prevValue,
                    isAreaSelected: true,
                    isAllSelected: false,
                    isSpecificSelected: false,
                }));
            }
            if (this.props.controls.applied.value === "CABANG") {
                this.setState((prevValue) => ({
                    ...prevValue,
                    isSpecificSelected: true,
                    isAreaSelected: false,
                    isAllSelected: false,
                }));
            }
        }
        if(this.props.isLoadLeasing && this.props.isLoadLeasing !== prevProps?.isLoadLeasing){
            this.loadLeasing()
        }
    }

    loadLeasing = async () => {
        this.props.triggerLoading();
        let {applied, cabang, wilayah} = this.props.controls;
        let filter = [];
        if (R.equals(applied?.value, "WILAYAH")) {
            filter = await this.fetchCabangByArea(wilayah?.value?.value);
        }
        if (R.equals(applied?.value, "CABANG")) {
            filter = cabang?.value.map(cab => cab.value);
        }
        await this.fetchDataLeasing(filter);
        this.props.onSuccessLoadLeasing()
        this.props.triggerLoading();
    }

    handleSelectedBranch = (e, type) => {
        const isChecked = e.target.checked;

        this.props.setValue("applied", isChecked ? type : "");
        if (type === "ALL") {
            this.setState((prevValue) => ({
                ...prevValue,
                isAllSelected: isChecked,
                isAreaSelected: false,
                isSpecificSelected: false,
            }));
            this.props.setValue("cabang", []);
            this.props.setValue("area", []);
            this.props.setValue("wilayah", null);
        }

        if (type === "WILAYAH") {
            this.setState((prevValue) => ({
                ...prevValue,
                isAreaSelected: isChecked,
                isAllSelected: false,
                isSpecificSelected: false,
            }));
            this.props.setValue("cabang", []);
            if (!isChecked) {
                this.props.setValue("wilayah", null);
                this.props.setValue("area", []);
            }
        }

        if (type === "CABANG") {
            this.setState((prevValue) => ({
                ...prevValue,
                isSpecificSelected: isChecked,
                isAreaSelected: false,
                isAllSelected: false,
            }));
            this.props.setValue("area", [])
            this.props.setValue("wilayah", null);
            if (!isChecked) {
                this.props.setValue("cabang", []);
            }
        }
    }

    handleStatus = (status) => {
        this.props.setValue("status", status);
    };

    fetchDataCabang = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            menuName: `Master Promo ${this.props.tab.toUpperCase()}`,
            setError: this.props.setError,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            const access = Array.isArray(this.props.menuAccess) ? this.props.menuAccess : [this.props.menuAccess]
            const filteredData = res.data.data.filter((item) =>
              access?.map((data) => data.idRefObj).includes(item.kodeCabang)
            );
            this.setState((prevValue) => ({
                ...prevValue,
                dataCabang: filteredData,
            }));
        }
    }

    fetchCabangByArea = async (area) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterCabang,
            menuName: `Master Promo ${this.props.tab.toUpperCase()}`,
            setError: this.props.setError,
            args: {
                filter: {
                    idWilayah: area,
                    status: "ACTIVE",
                },
            },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let {data} = res.data;
            return data.map(cab => cab.kodeCabang);
        } else {
            return [];
        }
    };

    fetchDataArea = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPromoWilayahByUserId,
            menuName: `Master Promo ${this.props.tab.toUpperCase()}`,
            setError: this.props.setError,
            args: {
                userId: this.props.userId,
            }
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataArea: res.data.data.map(item => mapToObjectDDL(item.value, item.key)),
            }));
        }
    };

    fetchDataLeasing = async (listKodeCabang = []) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
            menuName: `Master Promo ${this.props.tab.toUpperCase()}`,
            setError: this.props.setError,
            args: {paramFilters: {listKodeCabang}},
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataLeasing: res.data.data,
            }));
        }
    }

    handleChangePromoType = async (value) => {
        this.props.setValue("promoType", value);
        this.props.setValue("dataUnit", []);
        this.setState({confirmChangePromoType: false});
        if (R.equals(value?.value, "CREDIT")) {
            this.props.triggerLoading();
            let {applied, cabang, wilayah} = this.props.controls;
            let filter = [];
            if (R.equals(applied?.value, "WILAYAH")) {
                filter = await this.fetchCabangByArea(wilayah?.value?.value);
            }
            if (R.equals(applied?.value, "CABANG")) {
                filter = cabang?.value.map(cab => cab.value);
            }
            await this.fetchDataLeasing(filter);
            this.props.triggerLoading();
        }
    };

    handleChangeArea = async (value) => {
        let {promoType} = this.props.controls;
        this.props.setValue("wilayah", value);
        if (R.equals(promoType?.value?.value, "CREDIT")) {
            this.props.triggerLoading();
            let filter = await this.fetchCabangByArea(value?.value);
            await this.fetchDataLeasing(filter);
            this.props.triggerLoading();
        }
    };

    handleChangeCabang = async (value) => {
        let {promoType} = this.props.controls;
        this.props.setValue("cabang", value);
        if(!value) return 
        if (R.equals(promoType?.value?.value, "CREDIT")) {
            this.props.triggerLoading();
            let filter = value.map(v => v.value);
            await this.fetchDataLeasing(filter);
            this.props.triggerLoading();
        }
    };

    handleConfirmPromoType = (value) => {
        let {promoType} = this.props.controls;
        if (R.isEmpty(promoType?.value)) {
            this.handleChangePromoType(value);
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                confirmChangePromoType: !prevValue.confirmChangePromoType,
                tempPromoType: value,
            }));
        }
    };

    render() {
        return (
            <Fragment>
                <div className="flex-1" style={{marginBottom: "20px"}}>
                    <FlexView style={{gap: "20px", border: "black", borderWidth: "1px"}}>
                        <SimpleInput
                            id="input_text_promo_id"
                            name="promoId"
                            label="Promo ID"
                            mandatory
                            errorMessage={this.props.errors.promoId}
                            value={this.props.controls.promoId.value}
                            readOnly
                        />
                        <SimpleInput
                            id="input_text_promo_name"
                            name="promoName"
                            label="Nama Promo"
                            mandatory
                            errorMessage={this.props.errors.promoName}
                            value={this.props.controls.promoName.value}
                            readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                            onChange={({target}) => {
                                this.props.setValue(target.name, target.value)
                            }}
                        />
                    </FlexView>
                    <FlexView>
                        <div style={{width: "450px", marginRight: "35px"}}>
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>
                                    Periode Promo<span style={{color: "red"}}>*</span>
                                </h4>
                            </div>
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleDate
                                    name="startDate"
                                    nextdate
                                    mandatory
                                    date={this.props.controls.startDate?.value}
                                    maxDate={this.props.controls.endDate?.value}
                                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                    errorMessage={this.props.errors.startDate}
                                    onChange={(value) => this.props.setValue("startDate", M(value).format("DD-MM-YYYY"))}
                                />
                                <span className="margin-bottom-20px">s/d</span>
                                <SimpleDate
                                    name="endDate"
                                    backdate
                                    mandatory
                                    date={this.props.controls.endDate.value}
                                    minDate={this.props.controls.startDate?.value}
                                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                    errorMessage={this.props.errors.endDate}
                                    onChange={(value) => this.props.setValue("endDate", M(value).format("DD-MM-YYYY"))}
                                />
                            </FlexView>
                        </div>
                        <div style={{width: "150px"}}>
                            <SimpleInput
                                name="gracePeriod"
                                label="Grace Period"
                                box="number"
                                mandatory
                                value={this.props.controls.gracePeriod.value}
                                errorMessage={this.props.errors.gracePeriod}
                                readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                onValueChange={({value}) => this.props.setValue("gracePeriod", value)}
                            />
                        </div>
                    </FlexView>
                    <FlexView>
                        <div>
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>
                                    Cabang Berlaku<span style={{color: "red"}}>*</span>
                                </h4>
                            </div>
                            <FlexView style={{gap: "20px", marginRight: "20px"}}>
                                <SimpleCheckBox
                                    id="promoAllCabang"
                                    key="promoAllCabang"
                                    name="promoAllCabang"
                                    label="All"
                                    checked={this.state.isAllSelected}
                                    onChange={(e) => this.handleSelectedBranch(e, "ALL")}
                                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                />
                                <SimpleCheckBox
                                    id="promoArea"
                                    key="promoArea"
                                    name="promoArea"
                                    label="Wilayah"
                                    checked={this.state.isAreaSelected}
                                    onChange={(e) => this.handleSelectedBranch(e, "WILAYAH")}
                                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                />
                                <SimpleCheckBox
                                    id="promoSpecific"
                                    key="promoSpecific"
                                    name="promoSpecific"
                                    label="Spesifik Cabang"
                                    checked={this.state.isSpecificSelected}
                                    onChange={(e) => this.handleSelectedBranch(e, "CABANG")}
                                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                />
                            </FlexView>
                            {this.props.errors.applied && (
                                <p className="txt-site txt-11 color-red margin-top-5px">Field belum diisi</p>
                            )}
                        </div>
                        <div className="grid grid-2x" style={{width: "600px"}}>
                            <div id="grid-1" style={{width: "250px", marginRight: "30px"}}>
                                <SimpleDDL
                                    id="select_options_wilayah"
                                    name="wilayah"
                                    label="Wilayah"
                                    box="search"
                                    mandatory={this.state.isAreaSelected}
                                    errorMessage={this.props.errors.wilayah}
                                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW
                                        ? true
                                        : !this.state.isAreaSelected
                                    }
                                    value={this.props.controls.wilayah.value}
                                    options={this.state.dataArea}
                                    onChange={(value) => this.handleChangeArea(value)}
                                />
                            </div>
                            <div id="grid-2" style={{width: "250px", marginRight: "30px"}}>
                                <SimpleDDL
                                    id="select_options_cabang"
                                    name="cabang"
                                    label="Cabang Berlaku"
                                    box="multiselect"
                                    mandatory={this.state.isSpecificSelected}
                                    errorMessage={this.props.errors.cabang}
                                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW
                                        ? true
                                        : !this.state.isSpecificSelected
                                    }
                                    value={this.props.controls.cabang.value}
                                    options={this.state.dataCabang.map(item => mapToDDL(item.namaDealer, item.kodeCabang))}
                                    onChange={(value) => this.handleChangeCabang(value)}
                                />
                            </div>
                        </div>
                    </FlexView>
                    <FlexView>
                        <div style={{width: "250px", marginRight: "20px"}}>
                            <SimpleDDL
                                id="select_options_promo_type"
                                name="promoType"
                                label="Tipe Promo"
                                box="search"
                                mandatory
                                value={this.props.controls.promoType.value}
                                options={this.state.promoTypeOptions}
                                errorMessage={this.props.errors.promoType}
                                readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                onChange={(value) => this.handleConfirmPromoType(value)}
                            />
                        </div>
                        {this.props.controls.promoType?.value?.value === "CREDIT" && (
                            <div style={{width: "250px"}}>
                                <SimpleDDL
                                    id="select_options_leasing"
                                    name="leasingId"
                                    label="Leasing"
                                    box="search"
                                    mandatory={(this.props.controls.promoType?.value.value === "CREDIT")}
                                    errorMessage={this.props.errors.leasingId}
                                    value={this.props.controls.leasingId.value}
                                    options={this.state.dataLeasing?.map(item => mapToDDL(item.leasingName, item.leasingId))}
                                    readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                                    onChange={(value, {name}) => this.props.setValue(name, value)}
                                />
                            </div>
                        )}
                    </FlexView>
                    <FlexView>
                        <div className="txt-site txt-11 txt-main txt-bold margin-right-20px">
                            <h4>
                                Status<span style={{color: "red"}}>*</span>
                            </h4>
                        </div>
                        <ToggleButton
                            name="status"
                            label="Status"
                            value={R.equals(
                                this.props.controls.status.value,
                                Status.ACTIVE
                            )}
                            raadOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                            onToggle={(value) => {
                                if (this.props.activityType !== ACTIVITY_TYPE.VIEW) {
                                    this.handleStatus(!value ? Status.ACTIVE : Status.INACTIVE)
                                }
                            }}
                        />
                    </FlexView>
                </div>
                {this.state.confirmChangePromoType && (
                    <SimpleAlert
                        visible={this.state.confirmChangePromoType}
                        onClickClose={this.handleConfirmPromoType}
                        title={"Information"}
                        content={"Mengganti Tipe Promo akan menghapus detail promo, apakah anda yakin?"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={() => this.handleChangePromoType(this.state.tempPromoType)}>
                                    Ya
                                </SimpleButton>
                                <SimpleButton onClick={this.handleConfirmPromoType}>
                                    Tidak
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}
            </Fragment>
        )
    }
}

export default MasterPromoHeader;
